"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.latestValidLocationSchema = exports.latestLocationSchema = exports.deviceDataSchema = exports.locationDataSchema = exports.locationSchema = exports.locationHeaderSchema = void 0;
const zod_1 = require("zod");
exports.locationHeaderSchema = zod_1.z.object({
    lat: zod_1.z.string(),
    lng: zod_1.z.string(),
    accuracy: zod_1.z.string()
});
exports.locationSchema = zod_1.z.object({
    type: zod_1.z.string(),
    coordinates: zod_1.z.array(zod_1.z.number())
});
exports.locationDataSchema = zod_1.z.object({
    location: exports.locationSchema,
    accuracy: zod_1.z.number()
});
exports.deviceDataSchema = zod_1.z.record(zod_1.z.object({
    locationEnabled: zod_1.z.boolean(),
    deviceName: zod_1.z.string().optional()
}));
exports.latestLocationSchema = zod_1.z.union([exports.locationDataSchema, zod_1.z.object({})]);
exports.latestValidLocationSchema = zod_1.z.object({
    createdAt: zod_1.z.date()
}).merge(exports.locationDataSchema);
